import React from 'react'
import ContactIcons from './ContactIcons'


export default function ContactText() {

  const contactGreg =
    {
      "id": 2,
      "title": "Coach",
      "name": "Greg Wegrzynowicz",
      "email": "Greg@606Academy.com",
      "phone": "3126628256",
      "formattedPhone": "312-662-8256"
    }

   return (
    <div className='contact__container'>
      <div className="am">
        <h3>Now Hiring: Enrichment Instructor</h3>
        <div className="text-sm-left text-md-justify text-lg-justify">
          <p> 606 Academy is looking for an enthusiastic Assistant Enrichment Instructors to join our growing team! This is 1099 contractor position requires availability on Wednesdays from 12:30 PM to 2:30 PM. We are looking someone who loves working with kids, has a positive attitude, and is eager to learn. A background check is required. Join us in our growing startup! Send your resume to the email address below to be considered for a position.</p>
          <ContactIcons name={ contactGreg }/>           
          <p>
            <a className="contact-text-links" href={`mailto:${contactGreg.email}?Subject=Hello`}>
              {contactGreg.email}
            </a>
          </p>
      </div>
      </div>
      {/* <div className="pm">
        <h3>5pm-9pm Contact</h3>
        <div className="text-sm-left text-md-justify text-lg-justify">
          <p>{contactLeyna.title} {contactLeyna.name}</p>
          <ContactIcons name={ contactLeyna }/>           
          <p>
            <a className="contact-text-links" href={`mailto:${contactLeyna.email}?Cc=${contactGreg.email}&Subject=Hello`}>
              {contactLeyna.email}
            </a>
          </p>
          <p>
            <a className="contact-text-links" href={`tel:${contactLeyna.phone}`}>
              {contactLeyna.formattedPhone}
            </a>
          </p>
        </div>
      </div> */}
    </div>
   )
}